var ShowInfo = function ShowInfo(param) {
  switch (param) {
    case 'is-active':
      console.warn('Navigation is already initialized');
      break;
  }
};

export default ShowInfo;